<template lang="html">
  <ul class="answer-info-ul">
    <li v-for="(myAnswer, index) in myAnswers">
      <a class="head" href="javascript:;">
        <img
          :src="$$viewImage(myAnswer.answer_info.user_info.photo)"
          v-if="myAnswer.answer_info.user_info.photo"
        />
        <img
          src="//st.haiziwang.com/club/dynamic/m1.0/img/personal-default-avatar.png?imageView2/2/w/50/h/50/q/75"
          v-else
        />
        <span class="name">{{ myAnswer.answer_info.user_info.nickname }}</span>
      </a>
      <a
        :href="
          '//shequ.cekid.com/qa/answers/' +
          myAnswer.answer_info.answer_id +
          '?cmd=sqwdADetail&answer_id=' +
          myAnswer.answer_info.answer_id
        "
        ><p class="words">{{ myAnswer.answer_info.content }}</p></a
      >

      <div class="voice" v-if="myAnswer.answer_info.audio">
        <voice
          :item="mapAudio(myAnswer.answer_info.audio)"
          :id="myAnswer.answer_info.answer_id"
        ></voice>
        <div class="voice-listened" v-if="myAnswer.answer_info.listen_num">
          {{ myAnswer.answer_info.listen_num }}人已收听
        </div>
      </div>

      <a
        :href="
          '//shequ.cekid.com/qa/questions/' +
          myAnswer.question_info.question_id +
          '?cmd=sqwdQDetail&question_id=' +
          myAnswer.question_info.question_id
        "
      >
        <div class="qa-part">
          <p class="txt">
            <i class="ico-qa">问</i>{{ myAnswer.question_info.content }}
          </p>
          <div class="tips">
            <span class="tag">{{ myAnswer.categoryStr }}</span>
            <span class="num"
              >共{{ myAnswer.question_info.answer_num }}个回答</span
            >
          </div>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
import audio from '@/components/audio'

/*eslint-disable*/
export default {
    props: {
        myAnswers: {
            type: Array,
            default: () => []
        },
        getSize: {
            type: Number,
            default: 10
        },
    },
    data() {
        return {
            listLoading: true,
            timeStamp: null,
        }
    },
    components: { voice: audio },
    methods: {
      mapAudio(item) {
          return {
              src: item.url,
              progress: 0,
              title: '',
              currentTime: 0,
              duration: 0,
              length: item.length,
              state: false
          }
      }
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.answer-info-ul{
  li{
      display: block;
      padding: 0 rem(25px) rem(30px) ;
      .head{
          img{
              float:left;
              display: block;
              width: rem(50px);
              height: rem(50px);
              border-radius: 50%;
              overflow: hidden;
          }
          .name{
              padding-left: rem(18px);
              font-size: rem(28px);
              line-height: rem(50px);
              color:#666;
          }
      }
      .words{
          margin-left:rem(68px);
          margin-top: rem(4px);
          display: -webkit-box;
          max-height: rem(96px);
          color:#121212;
          font-size: rem(32px);
          line-height: rem(48px);
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
      }
      .qa-part{
          margin-left:rem(68px);
          margin-top: rem(14px);
          padding: rem(20px);
          background: #F4F4F4;
          border-radius: rem(10px);
          font-size: rem(28px);
          color:#666;
          .txt{
              display: -webkit-box;
              max-height: rem(88px);
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              .ico-qa{
                  margin-right: rem(10px);
                //   padding: rem(6px);
                  background: #ff6ea2;
                  color: #ffffff;
                  font-size: rem(24px);
                  line-height: rem(32px);
                  text-align: center;
                  border-radius: rem(10px);
                  vertical-align: rem(2px);
                  width:rem(32px);
                  height:rem(32px);
                  display: inline-block;
              }
          }
          .tips{
              margin-top: rem(14px);
              font-size: rem(22px);
              height: rem(36px);
              line-height: rem(36px);
              color:#999999;
              overflow: hidden;
              .num{
                  float: right;
              }
          }
      }
  }
}
.voice{
  position: relative;
  margin-left:rem(68px);
  .voice-listened{
    position: absolute;
    top:rem(28px);
    left: rem(440px);
    font-size: rem(26px);
    color: #999999;
  }
}
</style>
